<template>
  <sidebar-item
    v-if="hasDarkKitchen && !isAlmacenero"
    :link="{
      name: 'Franquicias',
      icon: 'ni ni-spaceship text-primary'
    }"
  >
    <sidebar-item
      :link="{
        name: 'Feedback',
        path: '/franquicias/feedback',
        icon: 'ni ni-single-02 text-primary'
      }"
    />
    <sidebar-item
      :link="{
        name: 'Regalos',
        path: '/regalos/canjear',
        icon: 'ni ni-tag text-warning'
      }"
    />
  </sidebar-item>
</template>

<script>
export default {
  name: 'FranchiseSection',
  computed: {
    hasDarkKitchen() {
      return this.$store.getters.getKitchenId !== null;
    },
    isAlmacenero() {
      return this.$store.getters.getUserRol === 'ALMACENERO';
    }
  }
};
</script>
